export default __webpack_public_path__ + "static/media/flickr.2e089745.svg";